var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('font-awesome-icon',{directives:[{name:"hammer",rawName:"v-hammer:tap",value:(_vm.back),expression:"back",arg:"tap"}],staticClass:"wcc auth-back",attrs:{"icon":['fas', 'chevron-left'],"title":"Back"}})}
var staticRenderFns = []

export { render, staticRenderFns }